/**
 * Indicates that a service has not been initialized yet.
 *
 * _Note: This value is for internal use only._
 */
export var EMPTY_VALUE = Symbol('EMPTY_VALUE');
//# sourceMappingURL=empty.const.js.map